
module.exports = {


    /**
     * Attribute for elements to make themselves trackable and bind to appropriate tracking
     */
    DATA_TRACKING_ID_ATTRIBUTE: 'data-tracking-id',


    /**
     * Attribute for elements to store value that's being used when tracking fires
     */
    DATA_TRACKING_VALUE_ATTRIBUTE: 'data-tracking-value',

    /**
     * Action names
     */
    ACTION_VIEW_REVIEW: 'view_review',
    ACTION_VIEW_CONTENT: 'view_content',
    ACTION_MMY_SELECT: 'mmy_select',
    ACTION_INVENTORY_SELECT: 'inventory_select',
    ACTION_TOOL_SELECT: 'tool_select',
    ACTION_TYPE_SELECT: 'type_select',
    ACTION_VIEW_PRICING_DETAILS: 'view_pricing_details',
    ACTION_PROVIDE_ZIP_CODE: 'provide_zip_code',
    ACTION_VIEW_VIN_DETAILS: 'view_vin_details',
    ACTION_SAVE_VEHICLE: 'save_vehicle',
    ACTION_RESET_NAVIGATION: 'reset_navigation',
    ACTION_DEALER_ENGAGEMENT: 'dealer_engagement',
    ACTION_WEBSITE_CLICKOUT: 'website_clickout',
    ACTION_WRITE_REVIEW: 'write_review',

    /**
     * Subaction names
     */
    SUBMIT_MMY: 'submit_mmy',
    SUBMIT_MAKE: 'submit_make',
    SUBMIT_MODEL: 'submit_model',

    MAKE_SELECT: 'make_select',
    MODEL_SELECT: 'model_select',
    YEAR_SELECT: 'year_select',

    NEW_CAR_SELECT: 'new_car',
    USED_CAR_SELECT: 'used_car',
    CAR_TYPES: 'car_types',
    CARS_FOR_SALE: 'cars_for_sale',
    RESEARCH: 'research',
    NEW_USED_CAR_SELECT: 'new_used_select',

    VIEW_EDMUNDS_REVIEW: 'view_edmunds_review',
    VIEW_SEARCH_RESULT: 'view_search_result',
    VIEW_SUMMARY: 'view_summary',
    VIEW_PRICING_DETAILS: 'view_pricing_details',
    VIEW_VIN_HIGHLIGHTS: 'view_vin_highlights',
    FILTER_SEARCH_RESULT: 'filter_search_result',
    SAVE_VIN_SUBMIT_EMAIL: 'save_vin_submit_email',
    VIEW_CONQUEST: 'view_conquest'
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/tracking/constant.js
// module id = 4
// module chunks = 36